import { Component } from '@angular/core';

@Component({
  selector: 'app-navigation-management',
  standalone: false,
  templateUrl: './navigation-management.component.html',
  styleUrls: ['./navigation-management.component.scss']
})
export class NavigationManagementComponent {
  activeTabIndex: string = '0';

  onTabChange(event: any) {
    this.activeTabIndex = event;
  }
}
